import { Stack, Typography, Divider, Chip, SxProps, Paper } from "@mui/material";
import { purple } from "@mui/material/colors";
import { Order, PaymentMethodsType, Cash } from "@/types";
import DataCell from "@/components/DataCell";
import DataCard from "@/pages/organization-orders/components/DataCard";
import Price from "@/components/Price";
import { getOrderDetails, getOrderItemPrice } from "@/utils/order";
import { ComponentProps } from "react";

interface Props {
    order: Order;
    title?: string;
    subtotal: number;
    deliveryValue?: number | string | null | React.ReactNode;
    taxesValue?: number | null;
    total: number;
    isMobile?: boolean;
    sx?: SxProps;
    PaperProps?: ComponentProps<typeof Paper>
}

const OrderItemsSummary = ({
    order,
    title,
    subtotal,
    deliveryValue,
    taxesValue,
    total,
    isMobile = false,
    sx,
    PaperProps
}: Props) => {
    const showDelivery = order?.flow === "delivery" && deliveryValue !== null && deliveryValue !== undefined;

    return (
        <Stack direction={isMobile ? "column" : "row"} spacing={2}>
            <DataCard title={title || "Productos"} sx={sx} PaperProps={PaperProps}>
                <>
                    <Stack spacing={1}>
                        {order.items?.map((item) => (
                            <Stack
                                key={`order-item-${item.id}`}
                                direction="row"
                                spacing={2}
                            >
                                <Typography variant="body2">
                                    {item.quantity}
                                </Typography>

                                <Stack flex={1}>
                                    <Typography variant="body2" flex={1}>
                                        {item.title}
                                    </Typography>

                                    <Typography variant="body1">
                                        {getOrderDetails(item)}
                                    </Typography>
                                </Stack>

                                <Typography variant="body1">
                                    <Price currency="NIO">
                                        {getOrderItemPrice(item)}
                                    </Price>
                                </Typography>
                            </Stack>
                        ))}
                    </Stack>

                    <Divider />

                    <Stack spacing={1}>
                        <DataCell
                            label="Subtotal"
                            value={<Price currency="NIO">{subtotal}</Price>}
                        />

                        {showDelivery && (
                            <DataCell
                                label="Envío"
                                value={
                                    <Stack
                                        direction="row"
                                        spacing={2}
                                        alignItems="center"
                                    >
                                        <Chip
                                            label="nuevo"
                                            size="small"
                                            sx={{
                                                backgroundColor: purple[500],
                                                color: "#ffffff",
                                            }}
                                        />

                                        <Typography variant="body2">
                                            {typeof deliveryValue === "number" ? (
                                                <Price currency="NIO">
                                                    {deliveryValue}
                                                </Price>
                                            ) : (
                                                deliveryValue
                                            )}
                                        </Typography>
                                    </Stack>
                                }
                            />
                        )}

                        {taxesValue !== null && (
                            <DataCell
                                label="IVA"
                                value={<Price currency="NIO">{taxesValue}</Price>}
                            />
                        )}

                        <DataCell
                            label="Total"
                            value={<Price currency="NIO">{total}</Price>}
                        />

                        <Divider />

                        {order.paymentDetails?.method === PaymentMethodsType.CASH &&
                            order.paymentDetails.value &&
                            (order.paymentDetails.value as Cash).amount !== undefined && (
                                <DataCell
                                    label="Paga con"
                                    value={
                                        <Price currency="NIO">
                                            {(order.paymentDetails.value as Cash).amount}
                                        </Price>
                                    }
                                />
                            )}
                    </Stack>
                </>
            </DataCard>
        </Stack>
    );
};

export default OrderItemsSummary;